
export const FREQUENCY_RENEWAL = {
    ONE_TIME_ONLY:"ONE_TIME_ONLY",
    CUSTOM_INTERVAL:"CUSTOM_INTERVAL"
}
